import { useLocation } from 'react-router';

import { Application } from '~/types/Application';
import { getStagePayload } from './getStagePayload';

export const isReadOnly = (application: Application | undefined, isItcardholderFlow?: boolean): boolean => {
  if (isItcardholderFlow) {
    return false;
  }
  const stagePayload = getStagePayload.wizard(application);
  const isReadOnlyApplication = application?.readOnly ?? false;
  const isReadOnlyStep = stagePayload?.activeStep.state === 'READ_ONLY';
  return isReadOnlyApplication || isReadOnlyStep;
};
